import { createHashRouter, Navigate, RouterProvider } from 'react-router-dom';
import Layout from './components/Layout';
import {
  currentCompanyConfigState,
  checkQuestionaryAccess,
} from '@laborability/commons';
import { useRecoilValue } from 'recoil';
import {
  CategoryPage,
  CookiePolicy,
  Home,
  MeasureDetailPage,
  NoPage404,
  PrivacyPolicy,
  SearchMisure,
  SeverancePay,
  ExEnergyScouter,
  TagPage,
  UserMenu,
  IssueReport,
  RatingPage,
  MeasureReport,
  QuestionaryIndex,
  QuestionaryMenu,
  UserAccount,
  MyBonus,
  SpecialCases,
  Logout,
  InformationArt13,
  PromoPrive,
  Serenis,
  Weltis,
  WelbeeSso,
} from './pages';
import Auth from './components/Auth';

export const APP_ROUTES = {
  HOME: 'home',
  MENU: 'menu',
  USER_ACCOUNT: 'user-account',
  QUESTIONARY_MENU: 'questionary-menu',
  FIFTH: 'fifth',
  FIFTH_01: 'fifth_01',
  FIFTH_02: 'fifth_02',
  FIFTH_03: 'fifth_03',
  FIFTH_04: 'fifth_04',
  FIFTH_05: 'fifth_05',
  FIFTH_06: 'fifth_06',
  SEVERANCE_PAY: 'severance-pay',
  EXENERGY_SCOUTER: 'exenergy-scouter',
  SERENIS: 'serenis',
  PROMO_PRIVE: 'promoprive',
  WELTIS: 'weltis',
  CATEGORY: 'category',
  MEASURE_DETAIL: 'measure-detail',
  TAG: 'tag',
  SEARCH_MISURE: 'search-misure',
  COOKIE_POLICY: 'cookie-policy',
  PRIVACY_POLICY: 'privacy-policy',
  QUESTIONARY: 'questionary',
  RATE_SERVICE: 'rate-service',
  REPORT_ISSUE: 'report-issue',
  REPORT_MEASURE: 'report-measure',
  MY_CONCESSIONS: 'my-concessions',
  MY_BONUS: 'my-bonus',
  SPECIAL_CASES: 'special-cases',
  QUESTIONARY_LOADER: 'questionary-loader',
  QUESTIONARY_COMPLETED_LOADER: 'questionary-completed-loader',
  LOGOUT: 'logout',
  ART_13: 'informativa-ex-art-13-gdpr',
  ENTI_BILATERALI: 'enti-bilaterali',
  WELBEE_SSO: 'welbee-sso',
};

export default function AppRoutes() {
  const { fifth_assignment, tfr, exenergy, promoprive, weltis, realm, serenis } = useRecoilValue(
    currentCompanyConfigState,
  );
  const hasQuestionaryAccess = checkQuestionaryAccess(realm ?? '');
  const fifthAssignmentRoutes = [
    {
      path: `${APP_ROUTES.TAG}/${APP_ROUTES.ENTI_BILATERALI}/:id`,
      element: <TagPage />,
      handle: {
        page_title: `Tag`,
      },
    },
  ];
  const severancePayRoutes = [
    {
      path: APP_ROUTES.SEVERANCE_PAY,
      element: <SeverancePay />,
      handle: {
        page_title: `Severance Pay`,
      },
    },
  ];
  const exEnergyScouterRoutes = [
    {
      path: APP_ROUTES.EXENERGY_SCOUTER,
      element: <ExEnergyScouter />,
      handle: {
        page_title: `EX-Energy Scouter`,
      },
    },
  ];
  const promoPriveRoutes = [
    {
      path: APP_ROUTES.PROMO_PRIVE,
      element: <PromoPrive />,
      handle: {
        page_title: `Promo Privè`,
      },
    },
  ];
  const serenisRoutes = [
    {
      path: APP_ROUTES.SERENIS,
      element: <Serenis />,
      handle: {
        page_title: `Serenis`,
      },
    },
  ];
  const weltisRoutes = [
    {
      path: APP_ROUTES.WELTIS,
      element: <Weltis />,
      handle: {
        page_title: `Weltis | Pianificazione finanziaria indipendente`,
      },
    },
  ];
  const pagesMileStone2 = [
    {
      path: APP_ROUTES.QUESTIONARY,
      element: <QuestionaryIndex />,
      handle: {
        page_title: `Questionario`,
      },
    },
    {
      path: APP_ROUTES.QUESTIONARY_MENU,
      element: <QuestionaryMenu />,
      handle: {
        page_title: `Questionario`,
      },
    },
    {
      path: APP_ROUTES.MENU,
      element: <UserMenu />,
      handle: {
        page_title: `Menù`,
      },
    },
    {
      path: APP_ROUTES.RATE_SERVICE,
      element: <RatingPage />,
      handle: {
        page_title: `Valuta il servizio`,
      },
    },
    {
      path: APP_ROUTES.REPORT_ISSUE,
      element: <IssueReport />,
      handle: {
        page_title: `Segnala un problema`,
      },
    },
    {
      path: APP_ROUTES.REPORT_MEASURE,
      element: <MeasureReport />,
      handle: {
        page_title: `Segnala un'agevolazione`,
      },
    },
    {
      path: APP_ROUTES.USER_ACCOUNT,
      element: <UserAccount />,
      handle: {
        page_title: `Acount`,
      },
    },
    {
      path: APP_ROUTES.MY_BONUS,
      element: <MyBonus />,
      handle: {
        page_title: `I miei bonus`,
      },
    },
  ];
  const router = createHashRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          element: <Auth />,
          children: [
            {
              index: true,
              path: '/',
              element: <Navigate to={APP_ROUTES.HOME} />,
            },
            {
              index: true,
              element: <NoPage404 />,
              handle: {
                page_title: `404 - Not found`,
              },
            },
            {
              path: APP_ROUTES.HOME,
              element: <Home />,
              handle: {
                page_title: 'Homepage',
              },
            },
            {
              path: `${APP_ROUTES.CATEGORY}/:id`,
              element: <CategoryPage />,
              handle: {
                page_title: `Categoria`,
              },
            },
            {
              path: `${APP_ROUTES.MEASURE_DETAIL}/:id`,
              element: <MeasureDetailPage />,
              handle: {
                page_title: `Dettagli misura`,
              },
            },
            {
              path: `${APP_ROUTES.TAG}/:id`,
              element: <TagPage />,
              handle: {
                page_title: `Tag`,
              },
            },
            {
              path: APP_ROUTES.SEARCH_MISURE,
              element: <SearchMisure />,
              handle: {
                page_title: `Ricerca libera`,
              },
            },
            {
              path: APP_ROUTES.SPECIAL_CASES,
              element: <SpecialCases />,
              handle: {
                page_title: `Casi particolari`,
              },
            },
            {
              path: APP_ROUTES.LOGOUT,
              element: <Logout />,
            },
            ...(tfr ? severancePayRoutes : []),
            ...(exenergy ? exEnergyScouterRoutes : []),
            ...(promoprive ? promoPriveRoutes : []),
            ...(serenis ? serenisRoutes : []),
            ...(weltis ? weltisRoutes : []),
            ...(fifth_assignment ? fifthAssignmentRoutes : []),
            ...(hasQuestionaryAccess ? pagesMileStone2 : []),
            {
              path: '*',
              element: <NoPage404 />,
            },
          ],
        },
        {
          path: APP_ROUTES.PRIVACY_POLICY,
          element: <PrivacyPolicy />,
          handle: {
            page_title: `Privacy Policy`,
          },
        },
        {
          path: APP_ROUTES.ART_13,
          element: <InformationArt13 />,
          handle: {
            page_title: `Informativa ex art. 13`,
          },
        },
        {
          path: APP_ROUTES.COOKIE_POLICY,
          element: <CookiePolicy />,
          handle: {
            page_title: `Cookie Policy`,
          },
        },
        {
          path: APP_ROUTES.WELBEE_SSO,
          element: <WelbeeSso />,
          handle: {
            page_title: `Welbee SSO`,
          },
        },
        {
          path: '*',
          element: <NoPage404 />,
        },
      ],
    },
    {
      path: '/*',
      element: <NoPage404 />,
    },
  ]);

  return <RouterProvider router={router} />;
}
